<template>
  <div>
    <v-layout row wrap>
      <v-flex p-t-30>
        <div class="tituloBox p-b-30 border-top">
          <div class="bg-primary barraTitulo"></div>
  
          <v-btn icon @click="openBox()" right absolute>
            <v-icon>unfold_more</v-icon>
          </v-btn>
  
          <h1 class="text-info font-size-18">
            Formulários e
            <strong>Declarações</strong>
          </h1>
        </div>
      </v-flex>
    </v-layout>
  
    <v-layout row wrap v-show="showBox">
      <v-flex infoDados>
        <v-card>
          <v-layout row wrap>
            <v-flex xs12 sm4 pa-0>
              <v-card>
                <v-card-title>
                  <h4>
                    <strong>{{$t('label.termoConcordanciaVeracidade')}}</strong>
                  </h4>
                </v-card-title>
  
                <v-divider></v-divider>
               
                <v-list dense>
                  <v-list-tile>
                    <v-list-tile-content v-show="!uploadDeclaracao.termoConcordanciaVeracidade.arquivoUpload || uploadDeclaracao.termoConcordanciaVeracidade.arquivoUpload == 'Não Encontrado'">
                      <span v-html="nomeAnexoIfCadatrado(uploadDeclaracao.termoConcordanciaVeracidade.arquivoUpload)"></span>
                    </v-list-tile-content>  
                    <v-list-tile-content style="align-items: center;">
                      <a v-show="uploadDeclaracao.termoConcordanciaVeracidade.arquivoUpload && uploadDeclaracao.termoConcordanciaVeracidade.arquivoUpload != 'Não Encontrado'">
                        <v-icon 
                          :color="uploadDeclaracao.termoConcordanciaVeracidade.uploadDeclaracaoSituacao === 1  ? 'red' : 'grey'"
                          :disabled="uploadDeclaracao.termoConcordanciaVeracidade.uploadDeclaracaoSituacao !== 1 || !uploadDeclaracao.termoConcordanciaVeracidade.arquivoUpload.includes('.pdf')"
                          @click="uploadDeclaracao.termoConcordanciaVeracidade.uploadDeclaracaoSituacao === 1 && uploadDeclaracao.termoConcordanciaVeracidade.arquivoUpload.includes('.pdf') ? baixarArquivo(uploadDeclaracao.termoConcordanciaVeracidade.arquivoUpload) : null"
                        >
                          attach_file
                        </v-icon>
                      </a>
                    </v-list-tile-content> 
                  </v-list-tile>
                </v-list>  
              </v-card> 
            </v-flex>
    
            <v-flex xs12 sm4 pa-0>  
              <v-card> 
                <v-card-title>
                  <h4> 
                    <strong>{{$t('label.comprovanteResidencia')}}</strong>  
                  </h4>
                </v-card-title>
                <br>
  
                <v-divider></v-divider>
  
                <v-list dense> 
                  <v-list-tile>  
                    <v-list-tile-content v-show="!uploadDeclaracao.comprovanteResidencia.arquivoUpload || uploadDeclaracao.comprovanteResidencia.arquivoUpload == 'Não Encontrado'">
                      <span v-html="nomeAnexoIfCadatrado(uploadDeclaracao.comprovanteResidencia.arquivoUpload)"></span>
                    </v-list-tile-content>  
                    <v-list-tile-content style="align-items: center;">
                      <a v-show="uploadDeclaracao.comprovanteResidencia.arquivoUpload && uploadDeclaracao.comprovanteResidencia.arquivoUpload != 'Não Encontrado'">
                        <v-icon 
                          :color="uploadDeclaracao.comprovanteResidencia.uploadDeclaracaoSituacao === 1 ? 'red' : 'grey'"
                          :disabled="uploadDeclaracao.comprovanteResidencia.uploadDeclaracaoSituacao !== 1 || !uploadDeclaracao.comprovanteResidencia.arquivoUpload.includes('.pdf')"
                          @click="uploadDeclaracao.comprovanteResidencia.uploadDeclaracaoSituacao === 1 && uploadDeclaracao.comprovanteResidencia.arquivoUpload.includes('.pdf') ? baixarArquivo(uploadDeclaracao.comprovanteResidencia.arquivoUpload) : null"
                        >
                          attach_file
                        </v-icon>
                      </a>
                    </v-list-tile-content>  
                  </v-list-tile>  
                </v-list>  
              </v-card> 
            </v-flex>
   
            <v-flex xs12 sm4 pa-0> 
              <v-card>
                <v-card-title>
                  <h4> 
                    <strong v-if="model.flagEstrangeiro === '0'">{{$t('label.procuracao')}}</strong>
                    <strong v-else>{{$t('label.procuracaoEstrangeiro')}}</strong>
                  </h4>
                </v-card-title>
                <br> 
                <v-divider></v-divider>
  
                <v-list dense> 
                  <v-list-tile> 
                    <v-list-tile-content v-show="!uploadDeclaracao.procuracao.arquivoUpload || uploadDeclaracao.procuracao.arquivoUpload == 'Não Encontrado'">
                      <span v-html="nomeAnexoIfCadatrado(uploadDeclaracao.procuracao.arquivoUpload)"></span>
                    </v-list-tile-content>  
                    <v-list-tile-content style="align-items: center;">
                      <a v-show="uploadDeclaracao.procuracao.arquivoUpload && uploadDeclaracao.procuracao.arquivoUpload != 'Não Encontrado'">
                        <v-icon 
                          :color="uploadDeclaracao.procuracao.uploadDeclaracaoSituacao === 1 ? 'red' : 'grey'"
                          :disabled="uploadDeclaracao.procuracao.uploadDeclaracaoSituacao !== 1 || !uploadDeclaracao.procuracao.arquivoUpload.includes('.pdf')"
                          @click="uploadDeclaracao.procuracao.uploadDeclaracaoSituacao === 1 && uploadDeclaracao.procuracao.arquivoUpload.includes('.pdf') ? baixarArquivo(uploadDeclaracao.procuracao.arquivoUpload) : null"
                        >
                          attach_file
                        </v-icon>
                      </a>
                    </v-list-tile-content> 
                  </v-list-tile> 
                </v-list> 
              </v-card> 
            </v-flex>
    
            <v-flex xs12 sm4 pa-0 v-show="model.tipoCertificado != '3'">  
              <v-card> 
                <v-card-title>
                  <h4> 
                    <strong>{{$t('label.declaracaoEmpregador')}}</strong> 
                  </h4>
                </v-card-title>
                <br>
                <v-divider></v-divider>
  
                <v-list dense> 
                  <v-list-tile> 
                    <v-list-tile-content v-show="!uploadDeclaracao.declaracaoEmpregador.arquivoUpload || uploadDeclaracao.declaracaoEmpregador.arquivoUpload == 'Não Encontrado'">
                      <span v-html="nomeAnexoIfCadatrado(uploadDeclaracao.declaracaoEmpregador.arquivoUpload)"></span>
                    </v-list-tile-content> 
                    <v-list-tile-content style="align-items: center;">
                      <a v-show="uploadDeclaracao.declaracaoEmpregador.arquivoUpload && uploadDeclaracao.declaracaoEmpregador.arquivoUpload != 'Não Encontrado'">
                        <v-icon 
                          :color="uploadDeclaracao.declaracaoEmpregador.uploadDeclaracaoSituacao === 1 ? 'red' : 'grey'"
                          :disabled="uploadDeclaracao.declaracaoEmpregador.uploadDeclaracaoSituacao !== 1 || !uploadDeclaracao.declaracaoEmpregador.arquivoUpload.includes('.pdf')"
                          @click="uploadDeclaracao.declaracaoEmpregador.uploadDeclaracaoSituacao === 1 && uploadDeclaracao.declaracaoEmpregador.arquivoUpload.includes('.pdf') ? baixarArquivo(uploadDeclaracao.declaracaoEmpregador.arquivoUpload) : null"
                        >
                          attach_file
                        </v-icon>
                      </a>
                    </v-list-tile-content> 
                  </v-list-tile> 
                </v-list> 
              </v-card>  
            </v-flex>
   
            <v-flex xs12 sm4 pa-0 v-show="model.tipoCertificado != '3'"> 
              <v-card>  
                <v-card-title>
                  <h4>  
                    <strong>{{$t('label.declaracaoSuperveniencia')}}</strong>
                  </h4>
                </v-card-title>
                <br>
                <v-divider></v-divider>
  
                <v-list dense> 
                  <v-list-tile> 
                    <v-list-tile-content v-show="!uploadDeclaracao.declaracaoSuperveniencia.arquivoUpload || uploadDeclaracao.declaracaoSuperveniencia.arquivoUpload == 'Não Encontrado'">
                      <span v-html="nomeAnexoIfCadatrado(uploadDeclaracao.declaracaoSuperveniencia.arquivoUpload)"></span>
                    </v-list-tile-content> 
                    <v-list-tile-content style="align-items: center;">
                      <a v-show="uploadDeclaracao.declaracaoSuperveniencia.arquivoUpload && uploadDeclaracao.declaracaoSuperveniencia.arquivoUpload != 'Não Encontrado'">
                        <v-icon 
                          :color="uploadDeclaracao.declaracaoSuperveniencia.uploadDeclaracaoSituacao === 1  ? 'red' : 'grey'"
                          :disabled="uploadDeclaracao.declaracaoSuperveniencia.uploadDeclaracaoSituacao !== 1 || !uploadDeclaracao.declaracaoSuperveniencia.arquivoUpload.includes('.pdf')"
                          @click="uploadDeclaracao.declaracaoSuperveniencia.uploadDeclaracaoSituacao === 1 && uploadDeclaracao.declaracaoSuperveniencia.arquivoUpload.includes('.pdf') ? baixarArquivo(uploadDeclaracao.declaracaoSuperveniencia.arquivoUpload) : null"
                        >
                          attach_file
                        </v-icon>
                      </a>
                    </v-list-tile-content>  
                  </v-list-tile> 
                </v-list> 
              </v-card> 
            </v-flex>
   
            <v-flex xs12 sm4 pa-0 v-show="model.tipoCertificado != '3'">  
              <v-card> 
                <v-card-title>
                  <h4> 
                    <strong>{{$t('label.declaracaoEnquadramento')}}</strong>
                  </h4>
                </v-card-title>
                <v-divider></v-divider>
  
                <v-list dense>  
                  <v-list-tile> 
                    <v-list-tile-content v-show="!uploadDeclaracao.declaracaoEnquadramento.arquivoUpload || uploadDeclaracao.declaracaoEnquadramento.arquivoUpload == 'Não Encontrado'">
                      <span v-html="nomeAnexoIfCadatrado(uploadDeclaracao.declaracaoEnquadramento.arquivoUpload)"></span>
                    </v-list-tile-content> 
                    <v-list-tile-content style="align-items: center;">
                      <a v-show="uploadDeclaracao.declaracaoEnquadramento.arquivoUpload && uploadDeclaracao.declaracaoEnquadramento.arquivoUpload != 'Não Encontrado'">
                        <v-icon 
                          :color="uploadDeclaracao.declaracaoEnquadramento.uploadDeclaracaoSituacao === 1  ? 'red' : 'grey'"
                          :disabled="uploadDeclaracao.declaracaoEnquadramento.uploadDeclaracaoSituacao !== 1 || !uploadDeclaracao.declaracaoEnquadramento.arquivoUpload.includes('.pdf')"
                          @click="uploadDeclaracao.declaracaoEnquadramento.uploadDeclaracaoSituacao === 1 && uploadDeclaracao.declaracaoEnquadramento.arquivoUpload.includes('.pdf') ? baixarArquivo(uploadDeclaracao.declaracaoEnquadramento.arquivoUpload) : null"
                        >
                          attach_file
                        </v-icon>
                      </a>
                    </v-list-tile-content> 
                  </v-list-tile> 
                </v-list> 
              </v-card>  
            </v-flex> 
          </v-layout>  
        </v-card>  
      </v-flex> 
    </v-layout>
  </div>
</template>
<script>
  import fornecedorService from "../../../services/fornecedorService"; /*Objeto com os principais servicos de Fornecedor */
  import util from "../../../plugins/util"; /*Objeto com metodos e funcoes utilizadas pelo sistema */

  export default {
    name: "resumo-familia",
    mixins: [util],
    props: {//Propriedades que o objeto recebe como parametro
      model: Object, /*Solicitacao atual do Fornecedor*/
      dominio: Object,
      enums: Object
    },
    created() /*Metodo de start do componente*/{
      //carrega os possiveis documentos de formularios e declaracoes
  
      let upload = {
        termoConcordanciaVeracidade: this.verificaDoc(
          this.model.uploadDeclaracao.find(x => x.tipDocumento === this.enums.tipoUploadDeclaracao.find(y => y.chave === 'TermoConcordanciaVeracidadeSaeb').valor)),
        comprovanteResidencia: this.verificaDoc(
          this.model.uploadDeclaracao.find(x => x.tipDocumento === this.enums.tipoUploadDeclaracao.find(y => y.chave === 'ComprovanteResidencia').valor)),
        procuracao: this.verificaDoc(
          this.model.uploadDeclaracao.find(x => x.tipDocumento === this.enums.tipoUploadDeclaracao.find(y => y.chave === 'Procuracao').valor)),
        declaracaoEmpregador: this.verificaDoc(
          this.model.uploadDeclaracao.find(x => x.tipDocumento === this.enums.tipoUploadDeclaracao.find(y => y.chave === 'DeclaracaoEmpregador').valor)),
        declaracaoSuperveniencia: this.verificaDoc(
          this.model.uploadDeclaracao.find(x => x.tipDocumento === this.enums.tipoUploadDeclaracao.find(y => y.chave === 'DeclaracaoSuperveniencia').valor)),
        declaracaoEnquadramento: this.verificaDoc(
          this.model.uploadDeclaracao.find(x => x.tipDocumento === this.enums.tipoUploadDeclaracao.find(y => y.chave === 'DeclaracaoEnquadramento').valor)),
      };
      this.uploadDeclaracao = upload

    },
    computed: {//Campos computados
      /* uploadDeclaracao() {
         if (!this.model.uploadDeclaracao) return {};
         return this.model.uploadDeclaracao;
       } */
    },
    data() {//Declaracao de variaveis
      return {
        showBox: true,
        uploadDeclaracao: Object,
      };
    },
    methods: {//Declaracao de todos os metodos
      openBox() {
        this.showBox = !this.showBox;
      },
      baixarArquivo(arquivo) {
        //baixar o documento
       
      const numCgcFornecedor = this.model.numCgcFornecedor.replace(/[\W_]+/g, "") ;
         
      fornecedorService.baixarArquivo(arquivo,numCgcFornecedor);
      },

      verificaDoc(obj) {
      if (obj != null) {
        return {
          arquivoUpload: obj.arquivoUpload,
          uploadDeclaracaoSituacao: obj.uploadDeclaracaoSituacao
        };
      }
      return {
        arquivoUpload: null,
        uploadDeclaracaoSituacao: null
      };
    },
      retornaEnumDescricao(_enum, valor) {
        //retorna a descricao do enum
        if (!valor || !this.enums[_enum]) return "";
        let retorno = this.enums[_enum].find(x => x.valor === valor);
        return retorno ? retorno.descricao : null;
      },
    }
  };
</script>

<style scoped> /*CSS especifico do componente*/
  .infoDados .v-card {
    padding: 15px;
  }
  .infoDados .linhaInfo {
    display: block;
    padding: 5px 0;
  }
  .theme--light.v-table thead {
    background: none;
  }
</style>